import './App.css';
import {useEffect, useState} from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";
import NeedsChart from "./needs/NeedsChart";
import NeedsList from "./needs/NeedsList";

let totalAmount = 0;
let totalPeople = 0;

const translations = {
  en: {
    total: "Total amount",
    covered: "Help covered",
    people: "people"
  },
  ua: {
    total: "Загальна сума",
    covered: "Охоплено допомогою",
    people: "людей"
  }
}


function App({lang}) {
  const [spendings, setSpendings] = useState();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [category, setCategory] = useState(null);

  const texts = translations[lang] || translations["ua"];

  const handleCategorySelect = (selectedCategory) => {
    setCategory(selectedCategory);
  }

  const loadSpendings = async () => {
    try {
      const response = await fetch(`https://api.edopomoga.gov.ua/v1/spendings?lang=${lang}`);
      if (response.ok) {
        const data = await response.json();
        const spendingsMap = new Map();

        data.forEach(region => {
          totalAmount += region.total;
          totalPeople += parseInt(region.people, 10);
          region.categories.forEach(category => {
            spendingsMap.set(category.name, (spendingsMap.get(category.name) + category.amount) || category.amount);
          })          
        })

        const spedingsList = Array.from(spendingsMap, ([name, value]) => ({ name, amount: value }));
        spedingsList.sort((a, b) => (b.amount - a.amount));
        setSpendings(spedingsList);
        setIsLoading(false);
      }
    } catch {
      setError(error.message);
    }
  }

  useEffect(() => {
    loadSpendings();
  }, []);

  if(isLoading) return <Spinner animation="border" role="status">
    <span className="visually-hidden">Loading...</span>
  </Spinner>

  if(error) return <p>{error}</p>

  return (
    <div className="App">
      <Container>
        <Row>
          <Col className="mb-4" xs={12} md={6}>
            <Card bvariant="flush">
              <Card.Header>{texts.total}</Card.Header>
              <Card.Body>
                <Card.Title>{totalAmount.toLocaleString()} ₴</Card.Title>
              </Card.Body>
            </Card>
          </Col>
          <Col className="mb-4" xs={12} md={6}>
            <Card variant="flush">
              <Card.Header>{texts.covered}</Card.Header>
              <Card.Body>
                <Card.Title>{totalPeople.toLocaleString()} {texts.people}</Card.Title>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col lg="6">
            <NeedsList 
                items={spendings} 
                activeIndex={category}
                onSelect={handleCategorySelect} />
            <br />
          </Col>
          <Col lg="6">
            <NeedsChart 
              items={spendings}
              activeIndex={category}
              onSelect={handleCategorySelect} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default App;
